export default __webpack_public_path__ + "static/5-27bff8d86ed33f69262db73ff8ad5e79.jpg";